import { BankBicOptions } from '@master/model/options/BankBicOptions'
export function parseFloatNumber (value: number | string | null) {
  if (typeof value === 'number') {
    return value
  }

  if (!value) {
    return null
  }

  return parseFloat(value.replace(/,/g, ''))
}

export function parseIntNumber (value: number | string | null) {
  if (typeof value === 'number') {
    return value
  }

  if (!value) {
    return null
  }

  return parseInt(value.replace(/,/g, ''))
}
export function parseToCorrectString (srcStr: string, targetStrList: string[]) {
  if (!srcStr || !targetStrList) return ''
  srcStr = srcStr.trim()
  const correctWord = targetStrList.find(target => {
    if (target.toLowerCase() === srcStr.toLowerCase()) {
      return target
    }
  })
  if (!correctWord) {
    return srcStr
  }
  return correctWord || ''
}

export function mapBankNameToBankCode (srcBankName: string) {
  if (!srcBankName) return ''
  // not sure why this function get called two time, it transform all to code first and then run again
  // this made the bank info not found as the second call is using the bank code not the bank name
  // for quick fix, i add two level of logic:
  // 1. mapping with the bank name
  // 2. mapping with the bank code
  // to make sure either name / code can be mapped
  const targetBank = BankBicOptions.find(bankOption => (bankOption.NAME.toLowerCase() === srcBankName.toLowerCase() || bankOption.CODE === srcBankName))

  if (!targetBank) {
    return 'NOT FOUND'
  }
  return targetBank.NAME
}
